<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal title="Application Details" ref="applicationDetails" size="xl" hide-footer>
        <RestorationDetails :tracking-number="trackingNumber"/>
      </b-modal>
    </b-row>
    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">Restoration Applications</span>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="flex m-2">
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="pre-waiting">
          <span class="h3 mx-auto">{{safeStats.draft}}</span>
        </div>
        <div class="pre-waiting">
          <span class="text-sm mx-auto">Drafts</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="waiting">
          <span class="h3 mx-auto">{{safeStats.pending}}</span>
        </div>
        <div class="waiting">
          <span class="text-sm mx-auto">In Queue</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="normal">
          <span class="h3 mx-auto">{{safeStats.assigned}}</span>
        </div>
        <div class="normal">
          <span class="text-sm mx-auto">Assigned</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="off-normal">
          <span class="h3 mx-auto">{{safeStats.escalated}}</span>
        </div>
        <div class="off-normal">
          <span class="text-sm mx-auto">Escalated</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="warning">
          <span class="h3 mx-auto">{{safeStats.queried}}</span>
        </div>
        <div class="warning">
          <span class="text-sm mx-auto">Queried</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="negative">
          <span class="h3 mx-auto">{{safeStats.rejected}}</span>
        </div>
        <div class="negative">
          <span class="text-sm mx-auto">Rejected</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="positive">
          <span class="h3 mx-auto">{{safeStats.approved}}</span>
        </div>
        <div class="positive">
          <span class="text-sm mx-auto">Approved</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="all">
          <span class="h3 mx-auto">{{safeStats.total}}</span>
        </div>
        <div class="all">
          <span class="text-sm mx-auto">Total</span>
        </div>
      </div>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-row  class="pt-2">
          <b-col>
            <AllRestorationSubmissions v-on:openDetails="openDetails"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import RestorationDetails from "@/views/home/services/restorations/submissions/RestorationDetails";
import AllRestorationSubmissions from "@/views/home/services/restorations/submissions/AllRestorationSubmissions";

export default {
  name: "RestorationApplications",
  components: {
    AllRestorationSubmissions,
    RestorationDetails,
  },
  data(){
    return{
      currentRoute: "pending",
      pendingCount:0,
      approvedCount:0,
      queriedCount:0,
      rejectedCount:0,
      allCount:0,
      trackingNumber:null,
    }
  },
  mounted() {
    this.fetchRestorationStats()
  },
  methods:{
    ...mapActions(["fetchRestorationStats"]),
    select(route){
      this.currentRoute = route
    },
    openDetails(trackingNumber){
      this.trackingNumber = trackingNumber
      this.$refs.applicationDetails.show()
    }
  },
  computed: {
  ...mapGetters(["getRestorationStatistics"]),
  safeStats() {
    const stats = this.getRestorationStatistics || {};
    return {
      draft: stats.draft != null ? stats.draft.toLocaleString() : '0',
      pending: stats.pending != null ? stats.pending.toLocaleString() : '0',
      assigned: stats.assigned != null ? stats.assigned.toLocaleString() : '0',
      escalated: stats.escalated != null ? stats.escalated.toLocaleString() : '0',
      queried: stats.queried != null ? stats.queried.toLocaleString() : '0',
      rejected: stats.rejected != null ? stats.rejected.toLocaleString() : '0',
      approved: stats.approved != null ? stats.approved.toLocaleString() : '0',
      total: stats.total != null ? stats.total.toLocaleString() : '0',
    };
  }
}
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";

.pre-waiting{
  @apply flex text-gray_title;
}

.off-normal{
  @apply flex text-blue-light;
}

.waiting{
  @apply flex text-gray;
}

.normal{
  @apply flex text-blue;
}

.positive{
  @apply flex text-green;
}

.warning{
  @apply flex text-orange;
}

.all{
  @apply flex text-flopurple;
}

.negative{
  @apply flex text-red;
}

.stat-count{
  display: inline;
  width: 11%;
  @apply my-1;
}

</style>